import { render } from "./EmergencyContactsList.vue?vue&type=template&id=bc84f610&scoped=true"
import script from "./EmergencyContactsList.vue?vue&type=script&lang=js"
export * from "./EmergencyContactsList.vue?vue&type=script&lang=js"

import "./EmergencyContactsList.vue?vue&type=style&index=0&id=bc84f610&lang=css"
import "./EmergencyContactsList.vue?vue&type=style&index=1&id=bc84f610&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc84f610"],['__file',"src/views/EmergencyContactsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc84f610"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc84f610', __exports__)) {
    api.reload('bc84f610', __exports__)
  }
  
  module.hot.accept("./EmergencyContactsList.vue?vue&type=template&id=bc84f610&scoped=true", () => {
    api.rerender('bc84f610', render)
  })

}


export default __exports__